import { v4 as uuidv4 } from 'uuid'
import { valByKeyWithDot } from './value'

export const emptyInList = (list, keys) => {
  return keys.every((key) => {
    return list.filter((item) => !!item[key] || item[key] === 0).length === 0
  })
}

export const debounce = (func, timeout = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

export const throttle = (func, timeout = 300) => {
  let isRunFunc = true
  return (...args) => {
    if (isRunFunc) {
      isRunFunc = false
      func.apply(this, args)
    }
    setTimeout(() => {
      isRunFunc = true
    }, timeout)
  }
}

export const getTextWidth = (txt, fontSize = 12, fontWeight = 400) => {
  const element = document.createElement('canvas')
  const context = element.getContext('2d')
  context.font = `${fontWeight} ${fontSize}px SFProDisplay`
  return Math.ceil(context.measureText(txt).width)
}

export const keyBy = (array, key, formatKey) => {
  const result = {}

  array.forEach((item) => {
    result[
      formatKey
        ? formatKey(valByKeyWithDot(item, key))
        : valByKeyWithDot(item, key)
    ] = item
  })

  return result
}

export const handleDuplicateArray = (arr) => {
  const seen = {}
  return arr.filter((item) => {
    return seen.hasOwnProperty(item) ? false : (seen[item] = true)
  })
}

export const getUnique = () => {
  return uuidv4()
}

export const range = (start, end) => {
  if (end < start || isNaN(end) || isNaN(start)) {
    return []
  }
  return Array(end - start + 1)
    .fill()
    .map((_, idx) => start + idx)
}

export const setNestedKey = (obj, path, data) => {
  if (path.length === 1) {
    obj[path] = data
    return
  }
  if (!obj[path[0]]) obj[path[0]] = {}
  return setNestedKey(obj[path[0]], path.slice(1), data)
}

export const removeAccents = (str) => {
  return str
    ?.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
}

export const getIsActiveFollowRoute = (location, route, children) => {
  const result = []
  getAllRoutesOfNested(children, result)

  return (
    (route && location.pathname.includes(route)) ||
    !result.every((route) => !location.pathname.includes(route))
  )
}

const getAllRoutesOfNested = (data, result = []) => {
  if (data) {
    data.forEach((item) => {
      if (item.route) {
        result.push(item.route)
      }
      if (item.children) {
        getAllRoutesOfNested(item.children, result)
      }
    })
  }
}

export const upperCaseFirstLetter = (str) => {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : str
}

export const lowerCaseFirstLetter = (str) => {
  return str ? str.charAt(0).toLowerCase() + str.slice(1) : str
}

export const sortByProp = (data, key, isDesc = true, isValString = false) => {
  if (isValString) {
    return data.sort((a, b) =>
      isDesc ? b[key].localeCompare(a[key]) : a[key].localeCompare(b[key]),
    )
  }

  return data.sort((a, b) => {
    if (a[key] > b[key]) {
      return isDesc ? -1 : 1
    }

    if (a[key] < b[key]) {
      return isDesc ? 1 : -1
    }

    return 0
  })
}

export const isObjectEqual = (x, y) => {
  if (x === y) return true
  // if both x and y are null or undefined and exactly the same

  if (!(x instanceof Object) || !(y instanceof Object)) return false
  // if they are not strictly equal, they both need to be Objects

  if (x.constructor !== y.constructor) return false
  // they must have the exact same prototype chain, the closest we can do is
  // test there constructor.

  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue
    // other properties were tested using x.constructor === y.constructor

    if (!y.hasOwnProperty(p)) return false
    // allows to compare x[ p ] and y[ p ] when set to undefined

    if (x[p] === y[p]) continue
    // if they have the same strict value or identity then they are equal

    if (typeof x[p] !== 'object') return false
    // Numbers, Strings, Functions, Booleans must be strictly equal

    if (!isObjectEqual(x[p], y[p])) return false
    // Objects and Arrays must be tested recursively
  }

  for (p in y) if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false
  // allows x[ p ] to be set to undefined

  return true
}
